import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/punto-de-venta/configuraciones/general',
  documento: 'pos-settings',
  acceso: 'sesion',
  filas: ['016'],
  redirecciones: [
    {
      desde: '/sistema/punto-de-venta/configuraciones',
      a: '/sistema/punto-de-venta/configuraciones/general',
      codigo: 302,
      cita: 'Areas/POS_Settings/Controllers/DashboardController.cs:37',
    },
  ],
  cita: 'Areas/POS_Settings/Controllers/SettingsController.cs:95',
} satisfies RutaProd & { redirecciones: { desde: string; a: string; codigo: 302; cita: string }[] };
